<template>
  <v-dialog v-model="isOpenDialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>SỬA THÔNG TIN TÀI KHOẢN NGÂN HÀNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-container>
        <v-col>
          <v-row md="12">
            <v-col md="2">
              <span>Tên lớp</span>
            </v-col>
            <v-col md="4">
              <span>Giáo viên chủ nhiệm</span>
            </v-col>
          </v-row>
          <v-row md="12" class="font-weight-bold">
            <v-col md="2" v-if="isOpenDialog">
              <span>{{ classBankAccount.title }}</span>
            </v-col>
            <v-col md="4" v-if="isOpenDialog">
              <span v-if="classBankAccount.headTeachers">{{ classBankAccount.headTeachers[0].name }}</span>
            </v-col>
          </v-row>
          <v-form ref="form" flat v-model="valid" lazy-validation>
            <v-row md="12" class="">
              <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="typeSelected"
                  :items="type"
                  clear-icon="mdi-close"
                  item-text="name"
                  item-value="value"
                  label="Phân loại tài khoản"
                  outlined
                  :rules="[rules.required]"
                  dense
                  clearable
                  class="required"
                  hide-details
                  @change="typeChange()"
                />
              </v-col>
              <v-col cols="12" sm="12">
                <v-select
                  :items="banks"
                  clear-icon="mdi-close"
                  item-text="shortName"
                  label="Tên ngân hàng"
                  placeholder="Chọn ngân hàng"
                  outlined
                  :rules="[rules.required]"
                  dense
                  clearable
                  class="required"
                  hide-details
                  return-object
                  @change="onChangeBank"
                  :value="inputBank"
                >
                  <template slot="selection" slot-scope="data">
                    {{ data.item.shortName }} - {{ data.item.name }}
                  </template>
                  <template slot="item" slot-scope="data"> {{ data.item.shortName }} - {{ data.item.name }} </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row md="12" class="d-flex justify-center mt-2">
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="accountNumber"
                  label="Số tài khoản"
                  return-object
                  clearable
                  flat
                  outlined
                  dense
                  :rules="[rules.isNumber, rules.required]"
                  required
                  class="required"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="accountHolder"
                  label="Tên tài khoản"
                  return-object
                  clearable
                  flat
                  outlined
                  required
                  dense
                  :rules="[rules.required]"
                  class="required"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-container>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save" width="100px">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { inputRules } from '@/plugins/rule'

export default {
  data() {
    return {
      isOpenDialog: false,
      rules: inputRules,
      valid: true,
      bankAccountId: '',
      classId: '',
      typeSelected: {},
      bankName: '',
      accountNumber: '',
      accountHolder: '',
      type: [
        { name: 'Tài khoản GVCN', value: 'default' },
        { name: 'Tài khoản khác', value: 'custom' },
      ],
      bin: '',
      inputBank: null,
    }
  },
  computed: {
    ...mapGetters({
      classBankAccount: 'bankAccount/classBankAccount',
    }),
    ...mapState({
      banks(state) {
        return state['bankAccount'].vnBanks
      },
    }),
  },
  methods: {
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),
    ...mapActions('bankAccount', ['fetchClassesData', 'fetchOneBankAccount', 'update', 'create']),
    onChangeBank(data) {
      this.bin = data.bin
      this.bankName = data.name || ''
    },
    async openDialog(idClass) {
      this.$loading.active = true
      await this.getDetail(idClass)
      await this.getInfoBank()
      this.classId = idClass
      if (this.classBankAccount.bankAccount) {
        this.bankAccountId = this.classBankAccount.bankAccount.id
      } else {
        this.bankAccountId = ''
      }
      this.$loading.active = false
      this.isOpenDialog = true
    },
    async getDetail(id) {
      let params = {
        id: id,
      }
      await this.fetchOneBankAccount(params)
    },
    cancel() {
      this.isOpenDialog = false
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    async getInfoBank() {
      if (this.classBankAccount.bankAccount) {
        this.typeSelected = { name: 'Tài khoản khác', value: 'custom' }
        this.bankName = this.classBankAccount.bankAccount.bankName
        this.accountNumber = this.classBankAccount.bankAccount.accountNumber
        this.accountHolder = this.classBankAccount.bankAccount.accountHolder
        this.bin = this.classBankAccount.bankAccount.bin
      } else if (!this.classBankAccount.bankAccount && this.classBankAccount.headTeachers[0].data.teachBankAccount) {
        this.typeSelected = { name: 'Tài khoản GVCN', value: 'default' }
        this.bankName = this.classBankAccount.headTeachers[0].data.teachBankAccount.bankName
        this.accountNumber = this.classBankAccount.headTeachers[0].data.teachBankAccount.accountNumber
        this.accountHolder = this.classBankAccount.headTeachers[0].data.teachBankAccount.accountHolder
        this.bin = this.classBankAccount.headTeachers[0].data.teachBankAccount.bin
      } else {
        this.typeSelected = { name: 'Tài khoản khác', value: 'custom' }
        this.bankName = ''
        this.accountNumber = ''
        this.accountHolder = ''
        this.bin = ''
      }
      if (this.bin) {
        this.inputBank = this.banks.find(x => x.bin === this.bin)
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        if (this.classBankAccount.bankAccount) {
          await this.updateBankAccount()
        } else {
          await this.createBankAccount()
        }
        this.isOpenDialog = false
        this.$loading.active = false
      }
    },
    async createBankAccount() {
      let params = {
        class: this.classId,
        type: this.typeSelected.value,
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountHolder: this.accountHolder,
        bin: this.bin,
      }
      await this.create(params)
    },
    async updateBankAccount() {
      let params = {
        type: this.typeSelected.value,
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountHolder: this.accountHolder,
        bin: this.bin,
      }
      await this.update({ id: this.bankAccountId, params: params })
    },
    typeChange() {
      switch (this.typeSelected) {
        case 'default':
          if (this.classBankAccount.headTeachers[0].data.teachBankAccount) {
            this.bankName = this.classBankAccount.headTeachers[0].data.teachBankAccount.bankName
            this.accountNumber = this.classBankAccount.headTeachers[0].data.teachBankAccount.accountNumber
            this.accountHolder = this.classBankAccount.headTeachers[0].data.teachBankAccount.accountHolder
          } else {
            this.bankName = ''
            this.accountNumber = ''
            this.accountHolder = ''
          }
          break
        case 'custom':
          this.bankName = ''
          this.accountNumber = ''
          this.accountHolder = ''
          break
        case null:
          this.reset()
      }
    },
    reset() {
      this.bankName = ''
      this.accountNumber = ''
      this.accountHolder = ''
    },
  },
}
</script>
